export default "__VITE_ASSET__K_n40rl3__"